import { GET_USERS_LIST, GET_USERS_LIST_SUCCESS, GET_USERS_LIST_FAILURE } from '../constants/get_users_list.constants';

export const getUsersList = searchText => ({ type: GET_USERS_LIST, searchText });
export const getUsersListSuccess = payload => ({ type: GET_USERS_LIST_SUCCESS, payload });
export const getUsersListFailure = error => ({ type: GET_USERS_LIST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/actions/get_users_list.actions.js